import { Link, Outlet, useLocation } from "react-router-dom";

import { AppHeader, isNavItemActive, type HeaderNavItem } from "@vellum/ui";
import { useAuth } from "@vellum/micro-app-auth";
import { isPayrollMgmt } from "@/lib/auth/roles";

export function RootLayout() {
  const { user } = useAuth();
  const location = useLocation();

  const navItems: HeaderNavItem[] = [];
  if (user) {
    navItems.push({
      label: "My Payroll",
      href: "/my-payroll",
      active: isNavItemActive(location.pathname, "/my-payroll"),
    });
    if (isPayrollMgmt(user)) {
      navItems.push({
        label: "Management",
        href: "/mgmt",
        active: isNavItemActive(location.pathname, "/mgmt"),
      });
    }
  }

  return (
    <div className="flex min-h-screen flex-col">
      <AppHeader
        brand="Payroll"
        accent="purple"
        className="print:hidden"
        renderLink={({ href, className, children }) => (
          <Link to={href} className={className}>
            {children}
          </Link>
        )}
        navItems={navItems}
        showLogo
      />
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-6 pb-10 sm:px-6 sm:py-8 sm:pb-12 lg:px-8 print:max-w-none print:p-0">
        <Outlet />
      </main>
    </div>
  );
}
